export const GET_PROPOSAL_STATUSES_QUERY = `
  query GetProposalStatuses($where: proposal_status_bool_exp = {}) {
    proposal_status(where: $where, order_by: { created_at: desc }) {
      id
      name
      description
      status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
    proposal_status_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_PROPOSAL_STATUS_BY_ID_QUERY = `
  query GetProposalStatusById($id: Int!) {
    proposal_status_by_pk(id: $id) {
      id
      name
      description
      status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`; 